/*
  Scroll-hintet under en tabel skal kun stå der, når tabellen faktisk er bredere
  end sin ramme. Hintet skrives ud to steder — i hver fane fra tab.liquid og i
  størrelses-popoveren fra tool-tip.liquid — ct-base.css holder det skjult, og
  den her fil sætter .is-needed på det, hvor det passer.

  Rammen findes ved at gå baglæns gennem søskende, til der står et element med
  en tabel i. Det er .table-wrapper i fanen og .tool-tip__content i popoveren,
  som begge har overflow-x: auto, men vi leder efter tabellen frem for efter et
  klassenavn, så en tredje placering virker af sig selv.

  Vi måler ved DOMContentLoaded og ved load, fordi .table-wrapper først laves af
  temaets egen JS. Bagefter holder to observatører øje: en ResizeObserver fanger,
  at en fane foldes ud, at skrifttypen lander, og at vinduet skifter størrelse —
  og en MutationObserver fanger, at popoveren får sin tabel lagt ind, hvilket
  først sker, når den åbnes. Et klik på knappen kan ikke bruges til det: temaet
  standser bobling, så en lytter på document når aldrig frem.

  Hintet er søskende til rammen, ikke barn af den, så det at vise det ændrer ikke
  rammens mål — observatøren kan ikke køre i ring.
*/
(function () {
  var HINT = '.table-scroll-hint';
  var KLASSE = 'is-needed';
  var observer = null;

  function rammenOver(hint) {
    var el = hint.previousElementSibling;
    while (el) {
      if (el.querySelector && el.querySelector('table')) {
        return el;
      }
      el = el.previousElementSibling;
    }
    return null;
  }

  function maal() {
    var hints = document.querySelectorAll(HINT);
    for (var i = 0; i < hints.length; i++) {
      var ramme = rammenOver(hints[i]);
      if (ramme && ramme.scrollWidth > ramme.clientWidth + 1) {
        hints[i].classList.add(KLASSE);
      } else {
        hints[i].classList.remove(KLASSE);
      }
      if (ramme && observer) {
        observer.observe(ramme);
      }
    }
  }

  if (window.ResizeObserver) {
    observer = new ResizeObserver(function () {
      maal();
    });
  } else {
    window.addEventListener('resize', maal);
  }

  if (window.MutationObserver) {
    var indsat = new MutationObserver(function () {
      maal();
    });
    var popovere = document.querySelectorAll('.tool-tip__content');
    for (var j = 0; j < popovere.length; j++) {
      indsat.observe(popovere[j], { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', maal);
  } else {
    maal();
  }

  window.addEventListener('load', maal);

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(maal);
  }
})();
